 document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('details.header__menu-disclosure[open]').forEach(function(d) {
      d.removeAttribute('open');
      d.setAttribute('aria-expanded', 'false');
    });
  });

  (function () {

    const currentPath = window.location.pathname.replace(/\/$/, '');

    // 1. Find the exact matching link in the mega menu
    const activeLink = document.querySelector(
      `.mega-menu a[href="${currentPath}"], .mega-menu a[href="${currentPath}/"]`
    );

    if (!activeLink) return;

    // Mark the leaf link itself
    activeLink.classList.add('is-active');

    // 2. Walk up to find the second-level heading (e.g. "Leather Hand Bags")
    //    Structure: a > li > ul.v-stack.gap-2.5 > li > a (second-level heading)
    const subList = activeLink.closest('ul.unstyled-list, ul[class*="gap-2"]');
    if (subList) {
      const parentLi = subList.closest('li');
      if (parentLi) {
        const secondLevelLink = parentLi.querySelector(':scope > a');
        if (secondLevelLink) {
          secondLevelLink.classList.add('is-active');
        }
      }
    }

    // 3. Walk up to find the top-level <summary> (e.g. "Leather Goods")
    const disclosure = activeLink.closest('details.header__menu-disclosure');
    if (disclosure) {
      const summary = disclosure.querySelector(':scope > summary');
      if (summary) {
        summary.classList.add('is-active');
      }
    }
  })();
  